const apps = [
  {
    title: "Modular construction",
    description:
      "Designed for off-site volumetric and panelised construction—integrating cleanly into pre-fabricated ceiling assemblies before they leave the factory.",
    img: "https://static.prod-images.emergentagent.com/jobs/96197346-3905-4338-9f6f-545a4a9da490/images/9f65852f32b1b5179f9656586f6a9ea16f51fea8f86bd40d8ce27f84efcd801d.png",
  },
  {
    title: "New house developers",
    description:
      "Specified for contemporary UK new-build schemes—working alongside solar PV and battery storage to help meet the Future Homes Standard.",
    img: "https://static.prod-images.emergentagent.com/jobs/96197346-3905-4338-9f6f-545a4a9da490/images/cde189e3c31fabcaf1a7a1c4b36b6fbee244914e6a94f3963caa07dc16450f3e.png",
  },
  {
    title: "Luxury residential homes",
    description:
      "Invisible warmth that preserves architectural finishes—no radiators, no visible plant, no compromise on the interior design.",
    img: "https://static.prod-images.emergentagent.com/jobs/96197346-3905-4338-9f6f-545a4a9da490/images/c9e4e1600dc4aba11026a7f57a0bde567bf7199d3bbce4fd520175274e465b20.png",
  },
  {
    title: "Self-build projects",
    description:
      "Straightforward to specify on architect-led and packaged self-builds such as Potton, Border Oak and Oakwrights timber-frame homes.",
    img: "https://static.prod-images.emergentagent.com/jobs/96197346-3905-4338-9f6f-545a4a9da490/images/28a4879f3c48b884a1c81dff2bb332fb23d4e9bf23edf94430d9634a0a4e264c.png",
  },
  {
    title: "Leisure homes & holiday accommodation",
    description:
      "Quiet, low-maintenance comfort for lodges, cabins and boutique holiday lets—where guest experience and energy efficiency both matter.",
    img: "https://images.unsplash.com/photo-1768578927102-81af7c7fcd40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxjb3p5JTIwYmVkcm9vbSUyMG1vZGVybiUyMHdvb2RlbiUyMGNhYmlufGVufDB8fHx8MTc3NzM3NDM2NXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Social housing & modern apartments",
    description:
      "An efficient, low-maintenance heating solution for new-build social housing schemes and modern apartments—delivering reliable comfort, minimal servicing and clean integration with rooftop solar PV.",
    img: "https://images.unsplash.com/photo-1597047084897-51e81819a499?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Small & large-scale retro-fit projects",
    description:
      "From individual houses to large-scale apartment blocks—delivering invisible, low-carbon heating that upgrades performance without disturbing the character of existing buildings.",
    img: "https://images.unsplash.com/photo-1768321902537-9c3e84b9f667?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Commercial spaces",
    description:
      "From boutique hospitality to design-led offices—delivering even radiant warmth without the visual intrusion of mechanical plant.",
    img: "https://static.prod-images.emergentagent.com/jobs/96197346-3905-4338-9f6f-545a4a9da490/images/7b87ca8986451a9d47e4f4e600b4c0cc3bb4cca68699dbc177330b5b7e4f1050.png",
  },
];

export default function Applications() {
  return (
    <section id="applications" data-testid="applications-section" className="py-10 bg-ecoh-surface">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="overline mb-6">Applications</div>
        <h2
          data-testid="applications-headline"
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-[-0.02em] leading-[1.05] text-ecoh-ink mb-16 md:mb-20"
        >
          Built for modern construction.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {apps.map((a, i) => (
            <article
              key={a.title}
              data-testid={`application-card-${i}`}
              className="group flex flex-col"
            >
              <div className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-ecoh-bg border border-ecoh-ink/5">
                <img
                  src={a.img}
                  alt={a.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <h3 className="mt-6 font-display text-xl md:text-2xl font-normal tracking-tight text-ecoh-ink">
                {a.title}
              </h3>
              <p className="mt-3 text-ecoh-muted text-[15px] leading-relaxed font-light">
                {a.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
